export default __webpack_public_path__ + "static/media/info.f14d2dcb.svg";